import React, { Component } from 'react';
import PrimaryButton from '../../commons/Buttons/PrimaryButton';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';

export const fields = ['email', 'password'];

const validate = values => {
    const errors = {};
    const requiredFields = ['email', 'password'];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "This field is required";
        }
    });

    if (values.email && !validator.isEmail(values.email)) {
        errors.email = "Invalid email address";
    }

    return errors;
};

class LoginForm extends Component {
    render() {
        const {
            handleSubmit,
            isFetching,
            errorMessage,
        } = this.props;

        return (
            <form onSubmit={handleSubmit} className="col-sm-12 col-md-12 col-xs-12">
                <div className="form-group form-md-line-input form-md-floating-label">

                    <Field name="email" id="email"
                        type="email" className="form-control" component="input" />

                    <label htmlFor="email">Email</label>
                </div>

                <div className="form-group form-md-line-input form-md-floating-label">

                    <Field name="password" id="password"
                        type="password" className="form-control" component="input" />

                    <label htmlFor="password">Password</label>
                </div>
                {errorMessage ? <strong className="text-danger">{errorMessage}</strong> : <strong>&nbsp;</strong>} 
                <div className="col-sm-12 col-md-12 col-xs-12 loginButton">
                    <div className="row">
                        <div className="col-sm-12 col-md-2">&nbsp;</div>

                        <PrimaryButton
                            name="Login"
                            type="submit"
                            loadingName="Authenticating"
                            isLoading={isFetching}
                        />

                        <div className="col-sm-12 col-md-2"></div>
                    </div>
                </div>
            </form>
        )
    }
}

export default reduxForm({
    form: 'LoginForm',
    validate,
    fields
})(LoginForm);


/** WEBPACK FOOTER **
 ** ./src/components/LoginForm/index.js
 **/